import { Component, Inject, Input } from '@angular/core';
import { TrainingProgramApplicationUtils } from 'src/app/utils/training-program-application.util';
import { ClassEnrolment } from '../../../models/class-enrolment.model';
import { CourseService } from '../../../services/course/course.service';
import { FormatUtil } from '../../../utils/format.util';

@Component({
    selector: 'app-record-of-completion',
    templateUrl: './record-of-completion.component.html',
    styleUrls: ['./record-of-completion.component.scss'],
    standalone: false
})
export class RecordOfCompletionComponent {
  enrolmentDto: ClassEnrolment;
  selection: any = { email: true, phone: false, fullsize: false, walletsize: false };
  formatUtil = FormatUtil;
  email: number = 0;
  download: number = 0;
  @Input() set Enrolment(v: ClassEnrolment) { this.enrolmentDto = v; }
  constructor(@Inject('CourseService') public courseService: CourseService) { }

  Send() {
    this.email = 0;
    this.courseService.SendRecordOfCompletion([this.enrolmentDto.RegistrationId!]).subscribe((b: Boolean) => this.email = b ? 1 : 2, err => this.email = 2);
  }

  Download() {
    this.download = 0;
    this.courseService.DownloadRecordOfCompletion([this.enrolmentDto.RegistrationId!]).subscribe((x: any) => {
      var a = document.createElement("a");
      a.setAttribute('style', 'display: none');
      document.body.appendChild(a);
      var data = [TrainingProgramApplicationUtils.Base64ToArrayBuffer(x.response)];
      var blob = new Blob(data, { type: 'octet/stream' });
      var url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = x.FileName;
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();

      this.download = 1;
    }, err => this.download = 2);
  }
}
